"use client";

import { NiceToMeetYou } from "@/components/NiceToMeetYou";
import HomeHero from "@/components/pages/home/HomeHero";
import HomeMore from "@/components/pages/home/HomeMore";
import { HomeShowReel } from "@/components/pages/home/HomeShowReel";
import { HomeWhatWeDo } from "@/components/pages/home/HomeWhatWeDo";
import { HomeWhatWeveCreated } from "@/components/pages/home/HomeWhatWeveCreated";
import { HomeWhoWeAre } from "@/components/pages/home/HomeWhoWeAre";
import { HowWeDoIt } from "@/components/pages/home/HowWeDoIt";
import FormSection from "@/components/pages/contentSections/FormSection";
import applyPageTransition from "lib/usePageTransition";
import { usePageTransition } from "mono/third-party/react-page-transitions-custom";

const QUICKSCAN_FORM = {
  title: "So… is it your time to <strong>shine?</strong>",
  subtitle: "Neem contact op en wij laten je zien waar de kansen liggen!",
  ctaText: "Verzenden",
  successTitle: "Bedankt voor je reactie",
  successMessage:
    "We komen zo snel mogelijk bij je terug. Kijk in de tussentijd voor meer inspiratie ;)",
  formName: "quickscan",
  formFields: [
    {
      label: "Naam",
      name: "naam",
      fieldType: "text",
      required: true,
      width: "half",
      placeholder: "Je volledige naam",
    },
    {
      label: "Bedrijfsnaam",
      name: "bedrijfsnaam",
      fieldType: "text",
      required: true,
      width: "half",
      placeholder: "Je bedrijfsnaam",
    },
    {
      label: "Emailadres",
      name: "email",
      fieldType: "email",
      required: true,
      width: "half",
      placeholder: "naam@bedrijf.nl",
    },
    {
      label: "Waar ben je naar op zoek?",
      name: "type",
      fieldType: "checkbox",
      required: true,
      width: "half",
      options:
        "Quickscan,Strategie,Brand Identity,Graphic Design,Beeld Visuals,Creatieve Campagne,Werving & Employer Branding,Online Marketing,Website,AI Oplossingen",
    },
    {
      label: "Bericht",
      name: "bericht",
      fieldType: "longtext",
      required: true,
      width: "full",
      placeholder: "Vertel ons meer over je project...",
    },
  ],
};

export default function HomePage({ projects }) {
  const { transitionState, from, to, data } = usePageTransition({
    ...applyPageTransition("HOME"),
  });

  return (
    <>
      <HomeHero />
      <HomeWhoWeAre />
      <HomeWhatWeDo />
      <HowWeDoIt />
      <HomeMore />
      <HomeWhatWeveCreated projects={projects} />
      <HomeShowReel />
      <FormSection data={QUICKSCAN_FORM} />
      <NiceToMeetYou />
    </>
  );
}
